import React from "react";
import "./MusicVideoModal.scss";
import { useTranslation } from "react-i18next";

interface MusicVideoModalProps {
  onClose?: () => void;
}

const MusicVideoModal: React.FC<MusicVideoModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const embedUrl = "https://vimeo.com/showcase/12105278/embed";

  return (
    <div className="musicVideo-modal">
      <div className="musicVideo-modal__frame">
        {onClose && (
          <button
            className="musicVideo-modal__close"
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        )}

        <div className="musicVideo-modal__content">
          <div className="musicVideo-modal__video-wrapper">
            <iframe
              className="musicVideo-modal__video"
              src={embedUrl}
              title="Spirit Bear Music Video"
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media"
              allowFullScreen
            />
          </div>
          <div className="musicVideo-modal__caption">
            <p className="musicVideo-modal__description">
              {t("music_video_description")}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MusicVideoModal;
